import { useState } from "react";

type Props = {
  logo: string;
  name: string;
  className?: string;
};

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 3)
    .toUpperCase();
}

export default function TeamLogo({ logo, name, className = "w-10 h-10" }: Props) {
  const [failed, setFailed] = useState(false);

  if (failed || !logo) {
    return (
      <div
        className={`${className} rounded-full bg-gray-700 text-white flex items-center justify-center font-bold shadow shrink-0`}
        title={name}
      >
        {initials(name)}
      </div>
    );
  }

  return (
    <img
      src={`/team-logos/${logo}`}
      alt={name}
      className={`${className} object-contain bg-white rounded-full shadow shrink-0`}
      onError={() => setFailed(true)}
    />
  );
}
